import { globalProps } from "neetocommons/initializers";

export const FILE_MIME_TYPES = {
  pdf: ["application/pdf"],
  doc: ["application/msword", "application/wps-writer"],
  docx: [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  xls: ["application/vnd.ms-excel"],
  xlsx: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  csv: ["text/csv"],
  txt: ["text/plain"],
  rtf: ["application/rtf", "text/rtf"],
  html: ["text/html"],
  htm: ["text/html"],
  md: ["text/markdown", "text/x-markdown"],
  zip: ["application/zip"],
  mp3: ["audio/mpeg"],
  wma: ["audio/x-ms-wma", "video/x-ms-asf"],
  mp4: ["video/mp4"],
  mpg: ["video/mpeg"],
  mpeg: ["video/mpeg"],
  flv: ["video/x-flv"],
  avi: ["video/x-msvideo"],
  jpg: ["image/jpeg"],
  jpeg: ["image/jpeg"],
  png: ["image/png"],
  gif: ["image/gif"],
  json: ["application/json"],
  epub: ["application/epub+zip"],
  aac: ["audio/aac"],
  svg: ["image/svg+xml"],
  ico: ["image/vnd.microsoft.icon"],
};

export const ERROR_CODES = {
  FILE_TOO_LARGE: "file-too-large",
  FILE_INVALID_TYPE: "file-invalid-type",
  TOO_MANY_FILES: "too-many-files",
};

export const DIRECT_UPLOAD_URL = "/api/direct_uploads";

export const MAX_FILE_SIZE =
  globalProps?.endUserUploadedFileSizeLimitInMb || 10;
